import { Route } from "react-router-dom";
import { PlanDetailPage } from "../pages/pms/plan";

export const locationManagerRoutes = (
  <Route path="lm/visits/:visitId" element={<PlanDetailPage />} />
);
